import { weatherStationsAPI } from "../weatherStationsApi"

export type WeatherStation = {
    id: string, 
    name: string, 
    latitude: number, 
    longitude: number 
}

type Measurement = {
    measuredAt: string,
    deviceName: string,
    values: [
        {
            typeCode: string,
            displayName: string,
            value: number,
            unit: string
        }
    ]
}

export const weatherStationsApiSlice = weatherStationsAPI.injectEndpoints({
    endpoints: builder => ({
        //  Аутентификация пользователя
        authenticateWeatherStationsService: builder.mutation<{ token: string }, { username: string, password: string }>({
            query: ({ username, password }) => ({
                url: `authenticate`,
                method: "POST",
                body: { username, password },
                headers: {
                    'Content-Type': 'application/json',
                }
            })
        }),
        //  Получить все метеостанции заказчика по его коду
        getWeatherStationsByCustomerCode: builder.query<[WeatherStation], { customerCode?: string }>({
            query: ({ customerCode } = {}) => ({
                url: `customers/by-code/${customerCode}/weather-stations`,
            }),
        }),
        //  Получить список сенсоров для конкретной метеостанции
        getWeatherStationDevices: builder.query<[{ id: string, serialNumber: string, typeCode: string, typeName: string }], { stationId?: string }>({
            query: ({ stationId } = {}) => ({
                url: `weather-stations/${stationId}/sensor-devices`,
            }),
        }),
        // Возвращает агрегированные данные по часам для указанной метеостанции, с учетом временной зоны клиента. Автоматически находит сенсор с данными о температуре воздуха.
        getWeatherStationSummaryByDate: builder.query<[{ hour: number, temperature?: number, weatherConditionIcon: string }], { stationId: string, date: string, timezone: string }>({
            query: ({ stationId, date, timezone }) => ({
                url: `weather/stations/${stationId}/summary/daily`,
                params: { date, timezone },
            })
        }),
        // Возвращает список точных временных меток за указанный час в выбранный день и в часовой зоне клиента.
        getDeviceTimestampsByHour: builder.query<[string], { deviceId: string, date: string, hour: number, timezone: string }>({
            query: ({ deviceId, date, hour, timezone }) => ({
                url: `weather/sensor-devices/${deviceId}/measurements/timestamps`,
                params: { date, hour, timezone }
            })
        }),
        // Возвращает полный набор измерений от конкретного сенсора, ближайший к указанной временной метке.
        getDetailedMeasurementsByDevice: builder.query<Measurement, { deviceId: string, timestamp: string }>({
            query: ({ deviceId, timestamp }) => ({
                url: `weather/sensor-devices/${deviceId}/measurements/detailed`,
                params: { timestamp },
            })
        }),
    })
})

export const {
    useAuthenticateWeatherStationsServiceMutation,
    useGetDetailedMeasurementsByDeviceQuery,
    useGetDeviceTimestampsByHourQuery,
    useGetWeatherStationDevicesQuery,
    useGetWeatherStationSummaryByDateQuery,
    useGetWeatherStationsByCustomerCodeQuery
} = weatherStationsApiSlice
